import { ITangNhaActionTypes } from "../../action-types/category/ITangNhaActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITangNhaReducer } from "../../reducer-model/category/ITangNhaReducer";

const initState: ITangNhaReducer = {
  status: eReducerStatusBase.is_not_initialization,
  tangNhas: [],
};
export const tangNhaReducer = (
  state: ITangNhaReducer = initState,
  action: ITangNhaActionTypes
): ITangNhaReducer => {
  switch (action.type) {
    case "TANG_NHA_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "TANG_NHA_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        tangNhas: action.payload,
      };
    case "TANG_NHA_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TANG_NHA_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        tangNhaEditing: action.payload,
      };
    case "TANG_NHA_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "TANG_NHA_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "TANG_NHA_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "TANG_NHA_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "TANG_NHA_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "TANG_NHA_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "TANG_NHA_DELETE_ERRR": 
        return {
            ...state,
            status: eReducerStatusBase.is_completed,
        };
    default:
      return state;
    }
}